export default "__VITE_ASSET__e64d7acd__"